/* ─────────────────────────────────────────────────────────────
   SECTION HEADER — Reusable centered title + subtitle block.
   Uses the global .section-title and .section-subtitle classes
   from index.css so styling is consistent everywhere.

   Props:
   - title:    required — the section heading
   - subtitle: optional — descriptive text under the heading
   ───────────────────────────────────────────────────────────── */
function SectionHeader({ title, subtitle }) {
  return (
    <div className="section-header">
      <h2 className="section-title">{title}</h2>
      {subtitle && <p className="section-subtitle">{subtitle}</p>}
    </div>
  );
}

export default SectionHeader;
